import React from "react";
import { Dialog } from "@material-ui/core";

type DPMultiStepModalSteps = { [key: string]: JSX.Element };

type DPMultiStepModalProps = {
  currentStep?: keyof DPMultiStepModalSteps;
  setCurrentStep: (currentStep?: string) => void;
  steps: DPMultiStepModalSteps;
};

const DPMultiStepModal = ({
  currentStep,
  setCurrentStep,
  steps,
}: DPMultiStepModalProps) => {
  const onClose = () => setCurrentStep();
  const open = !!currentStep;
  return (
    <Dialog open={open} onClose={onClose}>
      {(currentStep && steps[currentStep]) || <></>}
    </Dialog>
  );
};

export default DPMultiStepModal;
